import { Route, Routes } from '@angular/router';
import { SystemSettingsComponent } from '../../../common/components/system-settings/system-settings.component';
import { noAccessClassicGuard } from '../../../auth/routing/guards';
import { airlineClassicToV2Guard } from '../../../v2/guards/airline-classic-to-v2.guard';
import { AwardedContractsRoutes } from "./awarded-contracts";
import { createTenderRoutes } from './create-tender';
import { SuppliersRoutes } from './suppliers';
import { tenderRoutes } from './tender';
import { tenderListRoute } from './tenders';

// The v2 release (owner 2026-10-06): an airline user who uses v2 opens the v2 page of a classic
// page v2 has rebuilt (v2/airline-classic-to-v2.ts). First, so it decides before the classic
// guards redirect; on the children too, so moving inside a classic tender is caught.
const toV2: (route: Route) => Route = route => ({
    ...route,
    canActivate: [noAccessClassicGuard, airlineClassicToV2Guard, ...(route.canActivate ?? [])],
    canActivateChild: [airlineClassicToV2Guard, ...(route.canActivateChild ?? [])]
});

export const buyerModuleRoutes: Routes = [
    toV2(tenderListRoute),
    toV2(tenderRoutes),
    toV2(createTenderRoutes),
    SuppliersRoutes,
    toV2(AwardedContractsRoutes),
    {
        path: 'export-templates',
        canActivate: [noAccessClassicGuard],
        loadComponent: () => import('../../pages/export-templates/export-templates-list.component').then(m => m.ExportTemplatesListComponent)
    },
    {
        path: 'export-templates/new',
        canActivate: [noAccessClassicGuard],
        loadComponent: () => import('../../pages/export-template-editor/export-template-editor.component').then(m => m.ExportTemplateEditorComponent)
    },
    {
        path: 'export-templates/:id/edit',
        canActivate: [noAccessClassicGuard],
        loadComponent: () => import('../../pages/export-template-editor/export-template-editor.component').then(m => m.ExportTemplateEditorComponent)
    },
    {
        path: 'email-templates',
        loadComponent: () => import('../../pages/email-templates/email-templates-list.component').then(m => m.EmailTemplatesListComponent)
    },
    {
        path: 'email-templates/:key/edit',
        loadComponent: () => import('../../pages/email-templates/email-template-editor.component').then(m => m.EmailTemplateEditorComponent)
    },
    {
        path: 'system-settings',
        component: SystemSettingsComponent
    },
    {
        path: 'system-settings/:tab',
        component: SystemSettingsComponent
    },
    {
        path: 'system-settings/:tab/:subtab',
        component: SystemSettingsComponent
    }
];
